import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/index.css";
import App from "./Pages/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import Auth from "./Pages/auth";
import Insurance from "./Pages/insurance";
import Setup from "./Pages/setup";
import Capture from "./Pages/capture";
import { datadogLogs } from "@datadog/browser-logs";
import Income from "./Pages/income";
import AuthAcuant from "./Pages/authAcuant";
import RiskAnalysis from "./Pages/riskAnalysis";
import ComplianceCheck from "./Pages/ComplianceCheck";
import Selfie from "./Pages/selfie";
// Lazy so the ~20MB SmartCapture SDK only loads on its own route.
const SmartCapture = lazy(() => import("./Pages/smartCapture"));

const store = configureStore({ reducer: rootReducer });
const root = ReactDOM.createRoot(document.getElementById("root"));


datadogLogs.init({
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN_DEV,
  site: process.env.REACT_APP_DATADOG_SITE,
  service: process.env.REACT_APP_DATADOG_SERVICE,
  forwardErrorsToLogs: false,
  sampleRate: 100,
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/auth" element={<AuthAcuant />} />
          <Route path="/selfie" element={<Selfie />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/capture" element={<Capture />} />
          {/* <Route path="/authAlter" element={<AuthAlter />} /> */}
          <Route path="/income" element={<Income />} />
          <Route path="/riskAnalysis" element={<RiskAnalysis />} />
          <Route path="/complianceCheck" element={<ComplianceCheck />} />
          <Route path="/scan" element={<Suspense fallback={null}><SmartCapture /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
